import { useState } from 'react'
import { DashboardhMediumButton, Icon } from 'bd-web-components'
import {
  PRIMARY_BLUE_03,
  SECONDARY_GREEN_07,
} from 'bd-web-components/src/utils/dash-colors'
import { useMailingTerms } from '../../hooks/mailing-terms'
import {
  ButtonRow,
  CheckboxRow,
  CloseButton,
  TermsContainer,
  TermsDescription,
  TermsHeader,
  TermsLink,
} from './styles'

interface MailingTermsModalContentProps {
  accepted: boolean
  setAccepted: (value: boolean) => void
  onCancel: () => void
  onConfirm: () => void
}

export const MailingTermsModalContent = ({
  accepted,
  setAccepted,
  onCancel,
  onConfirm,
}: MailingTermsModalContentProps) => {
  const { fetchMailingTermsUrl } = useMailingTerms()
  const [loadingTerms, setLoadingTerms] = useState<boolean>(false)

  const handleOpenTerms = async () => {
    if (loadingTerms) return

    // Abrimos a aba de forma síncrona (ainda dentro do gesto do clique) para
    // não ser barrada pelo bloqueador de popup, e cortamos o opener por
    // segurança. A URL assinada é preenchida assim que o backend responde.
    const termsWindow = window.open('', '_blank')
    if (termsWindow) termsWindow.opener = null

    setLoadingTerms(true)
    try {
      const url = await fetchMailingTermsUrl()
      if (url && termsWindow) {
        termsWindow.location.href = url
      } else {
        termsWindow?.close()
      }
    } catch {
      termsWindow?.close()
    } finally {
      setLoadingTerms(false)
    }
  }

  return (
    <TermsContainer>
      <TermsHeader>
        <h2>Termos de uso — Download da base de mailing</h2>
        <CloseButton type="button" onClick={onCancel}>
          <Icon
            width={16}
            height={16}
            iconName={'x'}
            fill={PRIMARY_BLUE_03}
            classes="mailing-terms-close"
          />
        </CloseButton>
      </TermsHeader>

      <TermsDescription>
        A base de mailing contém dados pessoais dos compradores. Antes de baixar,
        leia os termos de uso e confirme que está de acordo com eles.
      </TermsDescription>

      <TermsLink type="button" onClick={handleOpenTerms} disabled={loadingTerms}>
        {loadingTerms ? 'Abrindo…' : 'Ler os termos de uso'}
      </TermsLink>

      <CheckboxRow>
        <input
          type="checkbox"
          checked={accepted}
          onChange={(e) => setAccepted(e.target.checked)}
        />
        <span>Li e aceito os termos de uso.</span>
      </CheckboxRow>

      <ButtonRow>
        <DashboardhMediumButton
          onClick={onCancel}
          // @ts-ignore
          type="button"
          background=""
          color=""
          height="52px"
          maxWidth="100%"
          variant={'outlined'}
        >
          <span>Cancelar</span>
        </DashboardhMediumButton>
        <DashboardhMediumButton
          onClick={onConfirm}
          // @ts-ignore
          type="button"
          background={accepted ? SECONDARY_GREEN_07 : 'disabled'}
          color=""
          height="52px"
          maxWidth="100%"
          variant={accepted ? 'contained' : 'disabled'}
        >
          <span>Continuar</span>
        </DashboardhMediumButton>
      </ButtonRow>
    </TermsContainer>
  )
}

export default MailingTermsModalContent
